export default __webpack_public_path__ + "27e34b38d8106788b3b85300d7058a97.png";